function d(e, i) {
  for (var n = -1, r = e == null ? 0 : e.length, u = 0, t = []; ++n < r; ) {
    var l = e[n];
    i(l, n, e) && (t[u++] = l);
  }
  return t;
}
export {
  d as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_arrayFilter.js
// module id = 1416
// module chunks = 41